import type { formulario as pt } from '../pt-BR/formulario';
import type { Traducao } from '../Traducao';

export const formulario = {
  saudacao: 'Hello, {{nome}}',
  abertaAte: 'Open until {{fim}}',
  semCampanha: 'No campaign is open right now.',
  selecione: 'Select',
  motivos: {
    SEM_VINCULO:
      'We could not find your professional record. Contact the team in charge of the campaign.',
    NAO_PARTICIPANTE:
      'You are not on the participant list for this campaign. Contact the team in charge of the campaign.',
    PARTICIPANTE_EXCLUIDO: 'You are no longer part of this campaign.',
    CAMPANHA_AGENDADA: 'The campaign starts on {{inicio}}.',
    CAMPANHA_FECHADA: 'The campaign is not accepting answers.',
  },
  somenteLeitura: 'Your answers can no longer be changed.',
  brinde: {
    pergunta: 'Would you like to receive an NTConsult year-end 2026 gift?',
  },
  camiseta: {
    titulo: 'T-shirt size',
    manterTamanho: 'Keep {{tamanho}}',
    trocar: 'Change',
    escolha: 'What is your t-shirt size?',
    exteriorHint: 'We do not send t-shirts abroad. The size you enter updates your record.',
  },
  entrega: {
    titulo: 'Can we deliver to this address or would you prefer another one?',
    aviso:
      'Estimated delivery: <strong>{{janela}}</strong>. For the address in Brazil that you provide, please check carefully that it is correct. <strong>Someone must be available to receive it when it arrives.</strong>',
    avisoDatas:
      'Estimated delivery: <strong>between {{inicio}} and {{fim}}</strong>. For the address in Brazil that you provide, please check carefully that it is correct. <strong>Someone must be available to receive it when it arrives.</strong>',
    avisoSemJanela:
      'For the address in Brazil that you provide, please check carefully that it is correct. <strong>Someone must be available to receive it when it arrives.</strong>',
    cadastro: 'Deliver to this address',
    outro: 'Deliver to another address',
    outroTitulo: 'Which address would you like to receive the year-end 2026 gift at?',
    completar: 'Complete the address on your record',
    separado:
      'We split the number and the complement from the street name. Please check that it is right.',
    numeroPodeEstarJunto: 'The number may be together with the street name. Check both fields.',
    corrigir: 'Not right? Fix it',
    enderecoOriginal: 'On your record it reads:',
    exterior: 'I live abroad and want to receive it abroad',
    exteriorDescricao:
      'For addresses abroad we send a pouch (necessaire), without personalization and without a t-shirt.',
    avisoExterior:
      'For addresses abroad, we send a <strong>non-personalized pouch (necessaire)</strong>, bought from a local store. Delivery time varies from country to country. Please check carefully that your address is correct. <strong>Someone must be available to receive it when it arrives.</strong>',
    cadastroExterior:
      'The address on your record is outside Brazil. To receive the personalized gift, enter an address in Brazil; or choose to receive it abroad.',
    exteriorTitulo: 'Which address abroad would you like to receive it at?',
    telefoneHint:
      'With the country code, for example +351 912 345 678. Used only for the delivery.',
  },
  campos: {
    cep: 'ZIP code (CEP)',
    logradouro: 'Street',
    logradouroExemplo: 'Street, avenue etc',
    numero: 'Number',
    complemento: 'Complement — optional',
    complementoExemplo: 'Apartment, house, block etc',
    bairro: 'Neighborhood',
    cidade: 'City',
    uf: 'State',
    estado: 'State',
    pais: 'Country',
    enderecoLivre: 'Address (street, number, complement)',
    endereco: 'Address',
    regiao: 'State, province or region — optional',
    codigoPostal: 'Postal code — optional',
    telefone: 'Phone',
    numeroOpcional: 'Number — optional',
    bairroOpcional: 'Neighborhood — optional',
  },
  oficial: {
    titulo: 'Official address on record',
    cidadeAusente: 'Cannot find your city? Contact the team in charge of the campaign.',
    semCidades: 'No city found',
    exteriorHint:
      'Outside Brazil, the city and state may not exist in the registry; in that case, the team completes it later.',
  },
  cep: {
    buscando: 'Looking up the address…',
    preenchido: 'Address filled in from the postal code. Check the details and enter the number.',
    parcial: 'This postal code covers the whole city. Enter the street and neighborhood.',
    naoEncontrado:
      'We could not find this postal code. Check the number or fill in the address manually.',
    indisponivel: 'The postal code lookup is unavailable right now. Fill in the address manually.',
    cidadeNaoCasou: 'We could not find the city in the registry list. Choose it manually.',
  },
  confirmar: {
    previsao: 'Expected delivery',
    semBrinde: "I don't want the gift",
    cadastro: 'Record',
    corrigirCadastro: 'Correct the address on my record',
    alterar: 'Change',
    intro:
      'Delivery of the gift depends on a correct address being provided and on someone being available to receive it. If you are not sure, feel free to go back and check.',
    enderecoCorreto: 'Yes, I confirm that my delivery address is correct.',
    recebedor: 'Yes, someone will be available to receive the delivery.',
    titulo: 'Confirmation',
  },
  enviar: 'Submit answers',
  salvarAlteracoes: 'Save changes',
  validacao: {
    cep: 'Enter an 8-digit ZIP code.',
    telefone: 'Enter a phone number with the country code, 8 to 15 digits.',
    tamanho: 'Use at most {{max}} characters.',
    obrigatorio: 'Required.',
  },
  resumo: {
    tamanho: 'T-shirt size',
    entrega: 'Delivery address',
    oficialSem: 'No change',
    entregaExterior: 'Delivery abroad (pouch)',
  },
  axiis: {
    camiseta: { sucesso: 'T-shirt size updated on your record.' },
    endereco: { sucesso: 'Official address updated on your record.' },
    pendente:
      'Your answers are saved. The update of your record is not finished yet; the team will finish it. You do not need to submit again.',
  },
  passos: {
    progresso: 'Step {{atual}} of {{total}}',
    continuar: 'Continue',
    voltar: 'Back',
  },
  mesmo: {
    pergunta: 'May we consider this your new address and update it in our systems?',
    sim: "Yes, this is my new address and I'd like to update it",
    nao: 'No, this is only where I want to receive the gift',
  },
  cadastro: {
    titulo: 'Address on your record',
    certo: "It's correct",
    corrigir: 'Correct it',
    pular: 'Skip',
  },
  respondido: {
    selo: 'Answered',
    quando: 'Sent on {{quando}}',
    alterar: 'Change answers',
  },
  link: {
    titulo: 'Campaign link',
    copiar: 'Copy link',
  },
} as const satisfies Traducao<typeof pt>;
